<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <div class="">
        <div class="image-order-item" v-for="(item, index) in images" :key="index">
          <span>{{ item.name }}</span>
          <el-select
            v-model="item.order" style="width: 60px;" placeholder=" " size="mini"
            @change="((val) => {selectOrder(val, index)})"
          >
            <el-option key="1" label="1" :value="1"></el-option>
            <el-option key="2" label="2" :value="2"></el-option>
          </el-select>
        </div>
      </div>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateInstance" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'TabImages',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    return {
      instance: {},
      images: [
        { code: 'group_360', name: '360° Group', order: 1 },
        { code: 'additional', name: 'Additional Image', order: 2 }
      ],
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.images) this.images = [...val.images]
        }
      },
      deep: true
    }
  },
  methods: {
    updateInstance: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk/mobile/instances/${this.instance._id}`
      const that = this
      const body = { images: this.images }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    selectOrder: function (val, index) {
      this.images[index].order = val
      this.images[index === 0 ? 1 : 0].order = val === 1 ? 2 : 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .image-order-item {
    width: 480px;
    height: 50px;
    background-color: #DBE7EA;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin-bottom: 20px;
  }
</style>
